module.exports =
  '_REGISTRATION':
    'NEW':
      'TITLE': '新規会員登録'
      'EMAIL': 'メールアドレス'
      'PASSWORD': 'パスワード'
      'FIRST_NAME': '名'
      'LAST_NAME': '姓'
      'BIRTH_DATE': '生年月日'
      'MALE': '男性'
      'FEMALE': '女性'
      'SIGN_UP': '登録'
      'GENDER': '性別'
      'COUNTRY': "国"
      'PREFECTURE': "都道府県"
      'COUNTRY_DEFAULT_TEXT': "国"
      'PREFECTURE_DEFAULT_TEXT': "都道府県"
      'URL_EXPIRED_1': 'URLの有効期限が切れています。'
      'URL_EXPIRED_2': '再度お試しください。'
      'PLACEHOLDER_PASSWORD': '英大文字・英小文字・数字・記号のうち3種以上かつ10桁以上(半角)'
      'PLACEHOLDER_PASSWORD_COMFIRM': '確認用（上部と同じ内容を入力）'
      'NAME': '氏名'
      'BIRTHDAY': '生年月日'
      'COUNTRY_TITLE': 'お住まいの国'
      'EMAIL_NEWSLETTER': 'メールマガジンを送信する'
      'CONTENT_EMAIL_NEWSLETTER_1': "ゴルフネットワークプラスTVの番組情報やお得な情報をお届け。"
      'CONTENT_EMAIL_NEWSLETTER_2': "メルマガ登録者限定キャンペーンも！"
      'CONTENT_EMAIL_NEWSLETTER_3': "不要な方はチェックを外してください。"
    'EDIT':
      'TITLE': 'アカウント設定'
      'GENERAL': "アカウント設定"
      'CHANGEPASSWORD': 'パスワード変更'
      'FORGOTPASSWORD': 'パスワードを忘れた方はこちら'
      'EMAIL': '@:_REGISTRATION.NEW.EMAIL'
      'CURRENTPASSWORD': '現在のパスワード'
      'NEWPASSWORD': '新しいパスワード'
      'CONFIRMPASSWORD': '新しいパスワード（確認)'
      'YOURNAME': '姓・名'
      'BIRTH_DATE': '@:_REGISTRATION.NEW.BIRTH_DATE'
      'GENDER': '@:_REGISTRATION.NEW.GENDER'
      'COUNTRY': "@:_REGISTRATION.NEW.COUNTRY"
      'PREFECTURE': "@:_REGISTRATION.NEW.PREFECTURE"
      'CHANGE_EMAIL': 'メールアドレス変更の方はこちら'
      'RULE_PASSWORD_LABEL': '英大文字・英小文字・数字・記号のうち3種以上かつ10桁以上(半角)'
    'EMAIL':
      'TITLE': '新規会員登録'
      'TAPPING_SIGN_UP_FIRST': ''
      'TAPPING_SIGN_UP_LAST': 'に同意して登録する。'
      'AND': 'と '
      'TERM': '利用規約 '
      'PRIVACE': '個人情報の取扱い '
    'EMAIL_SUCCESS':
      'TITLE': '新規会員登録'
      'PLEASE_CHECK_EMAIL': '認証用メールをご確認ください'
      'CHECK_EMAIL_DETAIL': '下記メールアドレスに、認証用メールをお送りしました。メール内に記載されているURLを開いてアカウント情報の入力を行ってください。'
      'NOT_RECEIVE_EMAIL': 'メールが届かない場合は、以下を確認してください。'
      'NOT_RECEIVE_EMAIL_1': '1.入力に誤りがないか'
      'NOT_RECEIVE_EMAIL_2': '2.迷惑メールフォルダに届いていないか'
      'PLEASE_CONTACT_1': '解決しない場合は、'
      'PLEASE_CONTACT_2': 'からお問合せください。'
      'PLEASE_CONTACT_HERE': 'こちら'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/i18n/ja.coffee